import { Link } from "react-router-dom";
import List from "../shared/list";

export function Analytics() {
  return (
    <div>
      <h2 style={{ textAlign: "left" }}>АНАЛИТИКА</h2>

      <List
        pointerCircle={true}
        data={[
          <Link
            to={
              "/articles/sekrety-fml-239-ili-pochemu-litsej-pobezhdaet-moskvichej-na-olimpiadakh"
            }
          >
            Секреты ФМЛ 239 или почему лицей побеждает москвичей на олимпиадах
          </Link>,
        ]}
      />
    </div>
  );
}
